import appTemplate from './app.html';

class AppController {
  static $inject = [
    '$state',
    'AuthService',
    'Timesheet',
    'ChangePasswordModal',
  ];

  isAuthenticated: boolean;
  currentUser: any;

  constructor(
    private $state,
    private AuthService,
    private Timesheet,
    private ChangePasswordModal,
  ) { }

  $onInit() {
    this.isAuthenticated = this.AuthService.isAuthenticated();

    if (this.isAuthenticated) {
      //Avoid 401 error if not authenticated
      this.AuthService.me().then((currentUser) => {
        this.currentUser = currentUser;
      });
    }
  }

  logout() {
    this.AuthService.logout();
    this.$state.go('login');
  }

  changePassword() {
    this.ChangePasswordModal.changePassword();
  }

  gotoTimesheet() {
    if (this.isAuthenticated) {
      this.Timesheet.gotoTimesheet();
    }
  }
}

export const AppComponent = {
  template: appTemplate,
  controller: AppController,
};
